
    import __i18nConfig from '@next-translate-root/i18n'
    import __loadNamespaces from 'next-translate/loadNamespaces'
    import { useCallback } from 'react';
import { Empty, Space, Spin } from 'antd';
import { useRouter } from 'next/router';
import { GetServerSidePropsContext } from 'next';
import axios, { AxiosResponse } from 'axios';
import useAPI from 'hooks/useAPI';
import SectionTab from 'components/common/SectionTab';
import IndividualBlog from 'components/blog/IndividualBlog';
import OpengraphTag from 'components/OpengraphTag';
import { FRONT_API_BASE_URL } from 'utils/config';
import { TabList } from 'constants/blog';
import { IBlogData, IIndividualBlog } from 'types/blog';
interface IStoryDetailProps {
    og_title: string;
    og_image: string;
    og_url: string;
    err: unknown;
}
function StoryDetail({ og_url, og_title, og_image, err }: IStoryDetailProps) {
    const router = useRouter();
    const { id } = router.query;
    const getStoriesDetail: () => Promise<AxiosResponse<IIndividualBlog>> = useCallback(async () => {
        return await axios.get(`/api/stories/${id}?populate=*`);
    }, [id]);
    const { data, isLoading, isError, error } = useAPI<IBlogData>(getStoriesDetail);
    const renderer = () => {
        if (isLoading) {
            // TODO loading 처리
            return <Spin />;
        }
        if (isError) {
            // TODO error 처리
            if (error?.code === 'ERR_BAD_REQUEST') {
                return (<Empty description="잘못된 요청이거나, 해당 비하인드 스토리가 존재하지 않습니다."/>);
            }
            return (<Empty description="데이터를 가져오는 도중 에러가 발생했습니다."/>);
        }
        if (!!data?.data) {
            const { title, subtitle, displayDate, content } = data.data.attributes;
            return (<IndividualBlog title={title} displayDate={displayDate} subtitle={subtitle} content={content}/>);
        }
        return (
        // TODO empty 처리
        <Empty description="해당 비하인드 스토리가 존재하지 않습니다."/>);
    };
    return (<>
      <OpengraphTag og_url={og_url} og_title={og_title} og_image={og_image} error={err}/>
      <Space direction="vertical" size="middle" style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
        }}>
        <SectionTab tabList={TabList}/>
        {renderer()}
      </Space>
    </>);
}
const getServerSideProps = async (context: GetServerSidePropsContext) => {
    const { locale, query } = context;
    const { id } = query;
    const default_og_title = locale === 'ko' ? '더핑크퐁컴퍼니 주식회사' : 'The Pinkfong Company';
    const default_og_url = locale === 'ko' ? FRONT_API_BASE_URL : `${FRONT_API_BASE_URL}/en`;
    const default_og_image = `${FRONT_API_BASE_URL}/images/thumbnail.png`;
    try {
        const storyDetailData: AxiosResponse<IIndividualBlog> = await axios.get(`/api/stories/${id}?populate=*`);
        return {
            props: {
                og_url: `${default_og_url}/blog/stories/${id}`,
                og_title: storyDetailData.data.data.attributes.title || default_og_title,
                og_image: storyDetailData.data.data.attributes.thumbnail?.data?.attributes
                    ?.url || default_og_image,
            },
        };
    }
    catch (err) {
        return {
            props: {
                og_url: default_og_url,
                og_title: default_og_title,
                og_image: default_og_image,
                err,
            },
        };
    }
};
export default StoryDetail;

    async function __Next_Translate__getServerSideProps__198075cf7ce__(ctx) {
      const res = await getServerSideProps(ctx)
      return {
        
        ...res,
        props: {
          ...(res.props || {}),
          ...(await __loadNamespaces({
            ...ctx,
            ...__i18nConfig,
            pathname: '/blog/stories/[id]',
            loaderName: 'getServerSideProps',
            loadLocaleFrom: __i18nConfig && __i18nConfig.loadLocaleFrom || ((l, n) => import(`@next-translate-root/locales/${l}/${n}`).then(m => m.default)),
          }))
        }
      }
    }
    export { __Next_Translate__getServerSideProps__198075cf7ce__ as getServerSideProps }
  